import { Injectable } from '@angular/core'

import { Survey } from '../models/survey'
import { Store } from './store'
import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class SurveyService extends Store<Survey> {

  constructor(private api: ApiService) {
    super(new Survey({ }))
  }

  public findByCode(code: string): void {
    this.reset()
    const url = 'ngin/registration/surveys/public/' + encodeURIComponent(code)
    this.api.findCurrent<Survey>(url, this.subject, Survey)
  }
}
